import React from 'react';

function ServicesHomeOne({ className }) {
    return (
        <section className={`dd-service-area pt-90 pb-100 ${className}`} id="service">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="dd-section-title text-center">
                            <h3 className="dd-title">
                                Designed with instructors <br /> and pupils in mind.
                            </h3>
                            <p>Designed by humans.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="dd-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="200ms"
                        >
                            <div className="icon">
                                <i class="fa-jelly-fill fa-regular fa-book"></i>
                            </div>
                            <h4 className="dd-title">Business Management</h4>
                            <p>Pupils, lessons, notes, docs, finances & more!</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="dd-single-service text-center mt-30 item-2 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="400ms"
                        >
                            <div className="icon">
                                <i class="fa-jelly-fill fa-regular fa-users"></i>
                            </div>
                            <h4 className="dd-title">Multi User</h4>
                            <p>Invite instructors, admins or family. Give pupils their app.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="dd-single-service text-center mt-30 item-3 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="600ms"
                        >
                            <div className="icon">
                               <i class="fa-jelly-fill fa-regular fa-tag"></i>
                            </div>
                            <h4 className="dd-title">Pupil Groups</h4>
                            <p>Group pupils by location, ability or anything you like.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="dd-single-service text-center mt-30 item-4 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="800ms"
                        >
                            <div className="icon">
                                <i class="fa-jelly-fill fa-regular fa-bolt"></i>
                            </div>
                            <h4 className="dd-title">Super Fast!</h4>
                            <p>All your school data instantly on and offline.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesHomeOne;
